import 'scss/services/photo-calculate-recg.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'
import 'js/libs/gt'
import { layer } from 'js/libs/utils-layer'

var isChrome = navigator.userAgent.toLowerCase().match(/chrome/)
var notSupportTip = isChrome ? '您的浏览器暂时不支持体验功能，请升级您的浏览器' : '您现在使用的浏览器暂时不支持体验功能，<br />推荐使用谷歌浏览器Chrome'
navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia

var uploadImage = (function (_self) {
  var bgImageList = [
    {
      url: 'https://wxres-ufile-ucloud.xfyun.cn/hera/services/photo-calculate-recg/taste1.jpg',
      result: {
        multi_line_info: {
          imp_line_info: [
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 0 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 0 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 }
          ]
        },
        recog_result: [
          {
            line_word_result: [
              { word_content: ['21 ÷ 7 = 3'] },
              { word_content: ['27 ÷ 3 = 9'] },
              { word_content: ['36 ÷ 9 = 4'] },
              { word_content: ['9 ÷ 3 = 3'] },
              { word_content: ['12 ÷ 2 = 6'] },
              { word_content: ['42 ÷ 6 = 7'] },
              { word_content: ['16 ÷ 8 = 2'] },
              { word_content: ['49 ÷ 7 = 7'] },
              { word_content: ['21 ÷ 3 = 9'] },
              { word_content: ['20 ÷ 5 = 4'] },
              { word_content: ['18 ÷ 9 = 2'] },
              { word_content: ['16 ÷ 4 = 4'] },
              { word_content: ['30 ÷ 6 = 5'] },
              { word_content: ['40 ÷ 8 = 5'] },
              { word_content: ['18 ÷ 6 = 2'] },
              { word_content: ['12 ÷ 4 = 3'] },
              { word_content: ['18 ÷ 2 = 9'] },
              { word_content: ['64 ÷ 8 = 8'] }
            ]
          }
        ]
      }
    },
    {
      url: 'https://wxres-ufile-ucloud.xfyun.cn/hera/services/photo-calculate-recg/taste2.jpg',
      result: {
        multi_line_info: {
          imp_line_info: [
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 0 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 }
          ]
        },
        recog_result: [
          {
            line_word_result: [
              { word_content: ['42 ÷ 7 = 6'] },
              { word_content: ['50 - 40 = 10'] },
              { word_content: ['60 + 30 = 90'] },
              { word_content: ['43 + 35 = 78'] },
              { word_content: ['5 × 7 = 35'] },
              { word_content: ['4 × 8 = 32'] },
              { word_content: ['36 ÷ 4 = 9'] },
              { word_content: ['300 - 200 = 100'] },
              { word_content: ['570 + 200 = 770'] },
              { word_content: ['680 - 600 = 80'] },
              { word_content: ['50 + 320 = 370'] },
              { word_content: ['35 ÷ 5 = 7'] },
              { word_content: ['570 - 350 = 220'] },
              { word_content: ['230 + 190 = 320'] },
              { word_content: ['550 + 350 = 900'] },
              { word_content: ['270 + 300 > 300 + 260'] },
              { word_content: ['210 + 60 = 10 + 260'] },
              { word_content: ['7800 - 4000 < 7800 - 400'] },
              { word_content: ['3200 + 300 < 3300 + 400'] },
              { word_content: ['600 + 96 < 600 + 960'] },
              { word_content: ['540 - 120 > 540 - 130'] },
              { word_content: ['1200 - 300 < 1200 + 30'] },
              { word_content: ['630 + 150 = 650 + 130'] }
            ]
          }
        ]
      }
    },
    {
      url: 'https://wxres-ufile-ucloud.xfyun.cn/hera/services/photo-calculate-recg/taste3.png',
      result: {
        multi_line_info: {
          imp_line_info: [
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 1 },
            { total_score: 0 },
            { total_score: 0 },
            { total_score: 1 }
          ]
        },
        recog_result: [
          {
            line_word_result: [
              { word_content: ['50厘米 = (5)分米'] },
              { word_content: ['800平方分米 = (8)平方米'] },
              { word_content: ['7000千克 = (7)吨'] },
              { word_content: ['38分米 = (3800)厘米'] },
              { word_content: ['9平方千米 = (90)公顷'] },
              { word_content: ['5000米 = (5)千米'] }
            ]
          }
        ]
      }
    }
  ]
  var index = 0
  var postIndex = 0
  var geetestResult = ''
  var captchaObj = ''
  var tempFile = ''
  var tempDataUrl = ''
  var Orientation = null
  _self.render = function () {
    for (let i = 0; i < 3; i++) {
      $('.photo-list li').eq(i).css(
        'background-image', 'url(' + bgImageList[i].url + ')'
      )
    }
    $('.photo-image').css(
      'background-image', 'url(' + bgImageList[0].url + ')'
    )
    _self.showResult(bgImageList[0].result)
  }
  _self.selectImage = function () {
    $('.photo-list li').click(function () {
      index = $(this).index()
      $('.photo-list').find('li.focus').removeClass('focus')
      $(this).addClass('focus')
      $('.photo-image').css(
        'background-image', 'url(' + bgImageList[index].url + ')'
      )
      _self.showResult(bgImageList[index].result)
    })
  }
  _self.checkAccept = function (accept, name) {
    var fileSuffix = name.toLowerCase().split('.').splice(-1)[0]
    var acceptArr = accept.split(',')
    return acceptArr.indexOf(fileSuffix) > -1 ? 'true' : false
  }
  _self.bindUpload = function (fileObj) {
    fileObj.on('change', function (e) {
      var getCookie = (key) => {
        return document.cookie.split(';').map(x => x.indexOf(key) > -1 ? x : '').join('').split(key + '=')[1]
      }
      console.log('点击了photo-calculate-recg.js')
      if (typeof window !== 'undefined') {
        if (window.IFlyCollector) {
          window.IFlyCollector.onEvent(
            'experience_photo_calculate_recg',
            {
              uid: `${getCookie('account_id')}`
            },
            'experience_function'
          )
        }
      }
      tempFile = this.files[0]
      EXIF.getData(tempFile, function () {
        EXIF.getAllTags(this)
        Orientation = EXIF.getTag(this, 'Orientation')
      })
      if (tempFile) {
        if (tempFile.size > parseInt(fileObj.attr('limitsize')) * 1024 * 1024) {
          $.alerts.alert('文件大小超出限制')
          return
        }
        var fr = new FileReader()
        if (_self.checkAccept(fileObj.attr('accept'), tempFile.name)) {
          fr.onload = function (e) {
            tempDataUrl = e.target.result
            $('#photoCalculateRecgImg')[0].value = null
            captchaObj.verify()
          }
          fr.readAsDataURL(tempFile)
        } else {
          $.alerts.alert('文件格式不符合要求')
        }
      }
    })
  }
  _self.postData = function (formData) {
    postIndex = index
    _self.recgLoading()
    $.ajax({
      url: '/herapi/product/itr',
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      mimeType: 'multipart/form-data',
      type: 'post',
      success: function (result) {
        if (result.code === 0 || result.code === '0') {
          bgImageList[postIndex].result = result.data.ITRResult
          if (postIndex === index) {
            _self.showResult(result.data.ITRResult)
          }
        } else {
          if (postIndex === index) {
            _self.recgError()
            $.alerts.alert(result.desc)
          } else {
            bgImageList[postIndex].result = 'error'
          }
        }
      },
      error: function () {
        if (postIndex === index) {
          _self.recgError()
          $.alerts.alert('图片上传失败，请重试。')
        } else {
          bgImageList[postIndex].result = 'error'
        }
      }
    })
  }
  _self.showResult = function (res) {
    if (res !== 'error' && res !== 'loading' && res.recog_result) {
      var scoreList = res.multi_line_info.imp_line_info
      var recgList = res.recog_result[0].line_word_result
      var total = scoreList.length
      var error = 0
      var resultStr = ''
      var str = ''
      $('.result-list').html('')
      for (var i = 0; i < total; i++) {
        var katexResult = ''
        try {
          katexResult = katex.renderToString(recgList[i].word_content[0])
        } catch (error) {
          katexResult = '该条公式无法展示。'
        }
        if (scoreList[i].total_score === 0 || scoreList[i].total_score === '0') {
          error++
        }
        resultStr += `<li class="result-list-content">
                      <span class="recg-result">${katexResult}</span>
                      <i class="icons icons-icon-${scoreList[i].total_score ? 'right' : 'error'}"></i>
                    </li>`
      }
      str = `<li class="result-list-header">
              <span>识别结果</span>
              <span>【批改${total}题，<b style="color: #d53010">${error}</b>题错误】</span>
            </li>` + resultStr
      $('.result-list').append(str)
    } else if (res === 'loading') {
      _self.recgLoading()
    } else {
      _self.recgError()
    }
  }
  _self.recgError = function (msg) {
    if (!msg) bgImageList[index].result = 'error'
    var errorStr = ''
    var errorMsg = msg || '拍照速算识别失败，请重试。'
    $('.result-list').html('')
    errorStr = `<li class="result-list-header">
                  <span>识别结果</span>
                </li>
                <li class="result-list-content">
                  <span class="recg-result">${errorMsg}</span>
                </li>`
    $('.result-list').append(errorStr)
  }
  _self.recgLoading = function () {
    bgImageList[index].result = 'loading'
    var loadingStr = ''
    $('.result-list').html('')
    loadingStr = `<li class="result-list-content">
                  <span class="recg-result">拍照速算识别中，请耐心等待...</span>
                </li>`
    $('.result-list').append(loadingStr)
  }
  _self.initGeetest = function () {
    $.ajax({
      url: '/herapi/plug/validate?t=' + (new Date()).getTime(),
      type: 'get',
      dataType: 'json',
      success: function (data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (res) {
          captchaObj = res
          captchaObj.onReady(function () {
            _self.bindUpload($('#photoCalculateRecgImg'))
          }).onSuccess(function () {
            _self.geetestResult = captchaObj.getValidate()
            if (!_self.geetestResult) {
              return alert('请完成验证')
            }
            _self.showPhotoImg()
          })
        })
      }
    })
  }
  _self.showPhotoImg = function () {
    var image = new Image()
    image.src = tempDataUrl
    var base64 = ''
    image.onload = function () {
      var expectWidth = this.naturalWidth
      var expectHeight = this.naturalHeight
      if (this.naturalWidth > this.naturalHeight && this.naturalWidth > 800) {
        expectWidth = 800
        expectHeight = expectWidth * this.naturalHeight / this.naturalWidth
      } else if (this.naturalHeight > this.naturalWidth && this.naturalHeight > 1200) {
        expectHeight = 1200
        expectWidth = expectHeight * this.naturalWidth / this.naturalHeight
      }
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      canvas.width = expectWidth
      canvas.height = expectHeight
      ctx.drawImage(this, 0, 0, expectWidth, expectHeight)
      if (navigator.userAgent.match(/iphone/i)) {
        if (Orientation !== '' && Orientation !== 1) {
          switch (Orientation) {
            case 6:
              _self.rotateImg(this, 'left', canvas)
              break
            case 8:
              _self.rotateImg(this, 'right', canvas)
              break
            case 3:
              _self.rotateImg(this, 'right', canvas)
              _self.rotateImg(this, 'right', canvas)
              break
          }
        }
        base64 = canvas.toDataURL('image/jpeg', 0.8)
      } else if (navigator.userAgent.match(/Android/i)) {
        var encoder = new JPEGEncoder()
        base64 = encoder.encode(ctx.getImageData(0, 0, expectWidth, expectHeight), 80)
      } else {
        if (Orientation !== '' && Orientation !== 1) {
          switch (Orientation) {
            case 6:
              _self.rotateImg(this, 'left', canvas)
              break
            case 8:
              _self.rotateImg(this, 'right', canvas)
              break
            case 3:
              _self.rotateImg(this, 'right', canvas)
              _self.rotateImg(this, 'right', canvas)
              break
          }
        }
        base64 = canvas.toDataURL('image/jpeg', 0.8)
      }
      $('.photo-image').css(
        'background-image', 'url(' + base64 + ')'
      )
      $('.photo-list').find('li.focus').css(
        'background-image', 'url(' + base64 + ')'
      )
      bgImageList[index].url = base64
      // var file = _self.dataURLtoFile(base64, tempFile.name)
      var file = _self.blobToFile(_self.dataURLtoBlob(base64), tempFile.name)
      var formData = new FormData()
      formData.append('file', file)
      formData.append('challenge', _self.geetestResult.geetest_challenge)
      formData.append('validate', _self.geetestResult.geetest_validate)
      formData.append('seccode', _self.geetestResult.geetest_seccode)
      _self.postData(formData)
    }
    image.onerror = function () {
      _self.recgError('图片加载失败，请上传正确的图片文件。')
    }
  }
  _self.dataURLtoBlob = function (dataurl, filename) {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  }
  _self.blobToFile = function (theBlob, fileName) {
    theBlob.lastModifiedDate = new Date()
    theBlob.name = fileName
    return theBlob
  }
  _self.dataURLtoFile = function (dataurl, filename) {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }
  _self.rotateImg = function (img, direction, canvas) {
    var minStep = 0
    var maxStep = 3
    if (img == null) return
    var height = img.height
    var width = img.width
    var step = 2
    if (step == null) {
      step = minStep
    }
    if (direction === 'right') {
      step++
      step > maxStep && (step = minStep)
    } else {
      step--
      step < minStep && (step = maxStep)
    }
    var degree = step * 90 * Math.PI / 180
    var ctx = canvas.getContext('2d')
    switch (step) {
      case 0:
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0)
        break
      case 1:
        canvas.width = height
        canvas.height = width
        ctx.rotate(degree)
        ctx.drawImage(img, 0, -height)
        break
      case 2:
        canvas.width = width
        canvas.height = height
        ctx.rotate(degree)
        ctx.drawImage(img, -width, -height)
        break
      case 3:
        canvas.width = height
        canvas.height = width
        ctx.rotate(degree)
        ctx.drawImage(img, -width, 0)
        break
    }
  }
  return _self
})({})

$(function () {
  serviceTopbar()
  initServiceOpen()
  $('.to-service-open').click(function () {
    showserviceOpenModal({
      urlParams: { 'currPage': '1' }
    }, {
      detailUrl: `${config.CONSOLE}/app/myapp`,
      appIdKey: 'keyword',
      needBase64: false
    })
  })
  $('#taste_button').click(function () {
    if (navigator.getUserMedia) {
      self.captchaObj && self.captchaObj.verify()
    } else {
      $.alerts.alert(notSupportTip)
    }
  })
  uploadImage.render()
  uploadImage.selectImage()
  uploadImage.initGeetest()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/photo-calculate-recg.js